import React, { useEffect, useRef, useState } from "react";
import { useUrlFriendlyToParameters } from 'helpers/urlFriendly';
import { useQuery } from "@tanstack/react-query";
import { getTeams } from "data/Querys";
import Loader from "components/general/Loader";
import NotAvailable from "components/common/NotAvailable";
import TeamsTable from "components/common/participants/TeamsTable";
import SelectorDiscipline from "components/common/selectors/selector-discipline/selectorDiscipline";
import SelectorEvent from "components/common/selectors/SelectorEvent";
import { Stack } from "react-bootstrap";
import SelectorNoc from "components/common/selectors/selector-noc";
import PageHeader from 'components/common/PageHeader';
import Label, { useLabels } from 'components/general/Label';
import useViewport from "components/general/useViewPort";
import { useGetH1 } from "helpers/commonCodes";
import { ALL_URL, SELECTOR_DISPLAY_TYPE } from "helpers/utils";
import { ResetFilterButton } from "components/common/ResetFilterButton";


const Teams = () => {
    const [dataState, setDataState] = useState([]);
    const { mirs_competition, mirs_language, mirs_discipline, mirs_event, mirs_noc } = useUrlFriendlyToParameters()
    const { breakPoint } = useViewport();
    const { h1s } = useGetH1({ mirs_competition });
    const [disciplines, setDisciplines] = useState([]);
    const [nocs, setNocs] = useState([]);
    const [events, setEvents] = useState([]);
    const inputRef = useRef(null);
    const [nameFilter, setNameFilter] = useState('');
    const isMobile = breakPoint === "sm" || breakPoint === "xs"
    const { data, isError, isLoading } = useQuery(
        {
            queryKey: ['teams', mirs_competition, mirs_language],
            queryFn: getTeams,
            refetchInterval: 0,
            //staleTime: 5000,
            //refetchIntervalInBackground: true
        });
    const fLabel = useLabels()
    const placeholder = fLabel({ data: 'HeaderTeam' });

    useEffect(() => {
        let filterData = data?.teams
        const discArray = h1s.filter(h => h.orisNo === 'N22').map(h => h.disciplineCode) || [];
        filterData = filterData?.filter(item => discArray.includes(item?.discipline?.code));
        filterData = filterData?.filter(item => item.current);

        let tempDisciplines = new Set();
        let tempNocs = new Set();
        let tempEvents = new Set();

        filterData?.forEach(dataItem => {
            let tempDiscipline = dataItem?.discipline?.code;
            let tempNoc = dataItem?.organisation?.code;
            let tempEventSet = new Set();

            if (mirs_discipline && mirs_discipline !== ALL_URL.ALL_DISC) {
                if (dataItem?.discipline?.code !== mirs_discipline) {
                    tempNoc = "";
                    tempEventSet.clear();
                } else {
                    dataItem?.registeredEvents?.forEach(re => tempEventSet.add(re?.code));
                }

                // if (mirs_event && mirs_event !== ALL_URL.ALL_EVENT) {
                //     if (dataItem?.event_code !== mirs_event) {
                //         tempDiscipline = "";
                //         tempNoc = "";
                //     }
                // }
            }

            if (mirs_noc && mirs_noc !== ALL_URL.ALL_NOC) {
                if (dataItem?.organisation?.code !== mirs_noc) {
                    tempDiscipline = "";
                    tempEventSet.clear();
                }
            }
            if (tempNoc) {
                tempNocs.add(tempNoc);
            }
            if (tempDiscipline) {
                tempDisciplines.add(tempDiscipline);
            }
            tempEventSet.forEach(te => tempEvents.add(te));
        });

        setDisciplines([...tempDisciplines]);
        setNocs([...tempNocs]);
        setEvents([...tempEvents])

        if (mirs_discipline && mirs_discipline !== "all-disc") {
            filterData = filterData?.filter(item => item?.discipline?.code === mirs_discipline)
        }
        if (mirs_noc && mirs_noc !== ALL_URL.ALL_NOC) {
            filterData = filterData?.filter(item => item?.organisation?.code === mirs_noc);
        }
        if (mirs_event && mirs_event !== "all-event") {
            filterData = filterData?.filter(item => item?.registeredEvents?.find(e => e?.code === mirs_event));
        }
        if (nameFilter)
            filterData = filterData?.filter(item => item?.name?.toLowerCase().includes(nameFilter.toLowerCase()));

        filterData = filterData?.map(item => ({ ...item, name: (item?.teamType === 'ORG' && item?.organisation?.description) ? item?.organisation?.description : item?.name }))
        setDataState(filterData);
    }, [data, mirs_noc, mirs_discipline, mirs_event, h1s, nameFilter]);



    if (isError) { return <NotAvailable label="LabelNoDataAvailable" />; }
    if (isLoading) { return <Loader />; }
    if (!data?.teams) { return <NotAvailable label="LabelNoDataAvailable" /> }



    const handleOnChange = event => {
        const { name, value } = event.target;
        let val = value;
        val = val.trimEnd();
        setNameFilter(val);
    };

    const clearFilterText = () => {
        if (inputRef?.current?.value) {
            inputRef.current.value = "";
        };
        setNameFilter("");
    }

    return (<>
        <PageHeader title={<Label data="LabelTeams" />} />
        <div className='mirs-page-container'>
            <Stack direction='horizontal' className='selectors-container'>
                <SelectorDiscipline display_type={SELECTOR_DISPLAY_TYPE.COMBO} page="teams" disciplinesList={disciplines} useDisciplinesList={true} />
                <SelectorNoc display_type={SELECTOR_DISPLAY_TYPE.COMBO} page="teams" nocsList={nocs} useNocList={true} />
                <SelectorEvent display_type={SELECTOR_DISPLAY_TYPE.COMBO} page="teams" eventList={events} useEventList={true} />
                <div className="d-flex competitor-search">
                    <input ref={inputRef} type="text" className="form-control" name="Team" id="Team"
                        placeholder={placeholder} onChange={handleOnChange} />
                </div>
                <ResetFilterButton clearFilterText={clearFilterText} filterText={nameFilter} page='teams' />

            </Stack>
            <div>
                {dataState && <TeamsTable data={dataState} key={`teams`} />}
            </div>
        </div>
    </>
    )
};

export default Teams

